var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.loadingState != 'error')?_c(_setup.VIntersectionObserver,{on:{"~enter":function($event){return _setup.handleVisible.apply(null, arguments)}}},[_c(_setup.NewBlogCarousel,{attrs:{"heading":_vm.heading,"data":_setup.carouselData,"viewAllLink":_vm.viewAllLink}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }